const Hidden = (props): JSX.Element => {
  if (props.if === true || props.unless === false) {
    return null
  }

  return props.children
}

export default Hidden
